import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import {WithUser} from '../../api/users/withMe';
import {getUserName, isEmptyObject} from '../../utils/misc';
import {clearImpersonationToken, isImpersonating} from '../../utils/ajax';
import TopBanner from '../../components/TopBanner';
import {RequireAuthenticationWithoutRouter} from '../auth/RequireAuthentication';


class ImpersonationBanner extends React.Component {

    endImpersonation = () => {
        clearImpersonationToken();
        window.location.replace('/login');
    };

    render() {
        if (!isImpersonating()) {
            return null;
        }

        return (
            <RequireAuthenticationWithoutRouter logoutAndRedirectIfNotLoggedIn={false}>
                {() => (
                    <WithUser>
                        {({user}) => (
                            <TopBanner visible={!isEmptyObject(user)}>
                                <p>
                                    <FormattedMessage
                                        {...messages.info}
                                        values={{userName: <b>{getUserName(user)}</b>}}/>
                                    <EndImpersonationButton
                                        onClick={this.endImpersonation}
                                    >
                                        <FormattedMessage {...messages.endImpersonation}/>
                                    </EndImpersonationButton>
                                </p>
                            </TopBanner>
                        )}
                    </WithUser>
                )}
            </RequireAuthenticationWithoutRouter>
        );
    }
}

const EndImpersonationButton = styled.button`
    margin-left: 20px;
    background-color: rgba(60, 76, 91, 0.57);
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: rgba(64, 83, 101, 0.57);
    }
`;


export default ImpersonationBanner;
